<app-side-menu>
  <div class="accounts-receivable-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-receipt me-3"></i>
                {{ isEditMode ? 'Editar Conta a Receber' : 'Nova Conta a Receber' }}
              </h1>
              <p class="page-subtitle">{{ isEditMode ? 'Atualize as informações da conta a receber' : 'Cadastre uma nova conta a receber' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="accounts-receivable-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Informações do Documento -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-file-alt me-2"></i>
              Informações do Documento
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-4">
                <label for="contractNumber" class="form-label">Número do Contrato</label>
                <input 
                  type="text" 
                  id="contractNumber"
                  class="form-control"
                  formControlName="contractNumber"
                  placeholder="Gerado pelo módulo de contratos ou informado manualmente">
              </div>

              <div class="col-md-4">
                <label for="ourNumber" class="form-label">Identificação Bancária</label>
                <input 
                  type="text" 
                  id="ourNumber"
                  class="form-control"
                  formControlName="ourNumber"
                  placeholder="Ex.: 00000012345-6">
              </div>

              <div class="col-md-4">
                <label for="bankReferenceNumber" class="form-label">Referência do Banco</label>
                <input 
                  type="text" 
                  id="bankReferenceNumber"
                  class="form-control"
                  formControlName="bankReferenceNumber"
                  placeholder="Número de referência/título no banco">
              </div>

              <div class="col-md-4">
                <label for="documentNumber" class="form-label">Número do Documento *</label>
                <input 
                  type="text" 
                  id="documentNumber"
                  class="form-control"
                  formControlName="documentNumber"
                  [class.is-invalid]="isFieldInvalid('documentNumber', 1)"
                  [class.is-valid]="documentNumber?.valid"
                  placeholder="Ex: FAT001234">
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('documentNumber', 1)">
                  {{ getFieldError('documentNumber', 1) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="documentType" class="form-label">Tipo do Documento *</label>
                <select 
                  id="documentType"
                  class="form-select"
                  formControlName="documentType"
                  [class.is-invalid]="isFieldInvalid('documentType', 1)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let type of documentTypes" [value]="type">
                    {{ type }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('documentType', 1)">
                  {{ getFieldError('documentType', 1) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="issueDate" class="form-label">Data de Emissão *</label>
                <input 
                  type="date" 
                  id="issueDate"
                  class="form-control"
                  formControlName="issueDate"
                  [class.is-invalid]="isFieldInvalid('issueDate', 1)">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('issueDate', 1)">
                  {{ getFieldError('issueDate', 1) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="invoiceNumber" class="form-label">Número da Nota Fiscal</label>
                <input 
                  type="text" 
                  id="invoiceNumber"
                  class="form-control"
                  formControlName="invoiceNumber"
                  placeholder="Ex: 123456">
              </div>
              
              <div class="col-md-6">
                <label for="saleOrderNumber" class="form-label">Número do Pedido de Venda</label>
                <input 
                  type="text" 
                  id="saleOrderNumber"
                  class="form-control"
                  formControlName="saleOrderNumber"
                  placeholder="Ex: PV001234">
              </div>
              
              <div class="col-12">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control"
                  formControlName="description"
                  rows="3"
                  placeholder="Descrição da conta a receber..."></textarea>
              </div>
            </div>
          </div>

          <!-- Step 2: Valores e Vencimento -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-calculator me-2"></i>
              Valores e Vencimento
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="originalAmount" class="form-label">Valor Total *</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="originalAmount"
                    class="form-control"
                    formControlName="originalAmount"
                    appCurrencyShiftMask
                    [class.is-invalid]="isFieldInvalid('originalAmount', 2)"
                    placeholder="0,00">
                </div>
                <small class="text-muted" *ngIf="isBatchMode">Valor total do acordo; dividido igualmente entre as parcelas.</small>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('originalAmount', 2)">
                  {{ getFieldError('originalAmount', 2) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="dueDate" class="form-label">
                  {{ isBatchMode ? 'Data do 1º vencimento *' : 'Data de Vencimento *' }}
                </label>
                <input 
                  type="date" 
                  id="dueDate"
                  class="form-control"
                  formControlName="dueDate"
                  [class.is-invalid]="isFieldInvalid('dueDate', 2)">
                <small class="text-muted" *ngIf="isBatchMode">Início da cobrança recorrente (demais parcelas seguem o intervalo).</small>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('dueDate', 2)">
                  {{ getFieldError('dueDate', 2) }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="discountAmount" class="form-label">Desconto</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="discountAmount"
                    class="form-control"
                    formControlName="discountAmount"
                    appCurrencyShiftMask
                    placeholder="0,00">
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="interestAmount" class="form-label">Juros</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="interestAmount"
                    class="form-control"
                    formControlName="interestAmount"
                    appCurrencyShiftMask
                    placeholder="0,00">
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="fineAmount" class="form-label">Multa</label>
                <div class="input-group">
                  <span class="input-group-text">R$</span>
                  <input 
                    type="text" 
                    id="fineAmount"
                    class="form-control"
                    formControlName="fineAmount"
                    appCurrencyShiftMask
                    placeholder="0,00">
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="totalInstallments" class="form-label">Quantidade de títulos / parcelas</label>
                <input 
                  type="number" 
                  id="totalInstallments"
                  class="form-control"
                  formControlName="totalInstallments"
                  min="1"
                  max="120"
                  placeholder="Ex: 12">
              </div>

              <!-- Recorrência / batch -->
              <div class="col-12" *ngIf="isBatchMode">
                <div class="batch-recurrence-panel">
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <i class="fas fa-layer-group text-primary"></i>
                    <strong>Geração em lote</strong>
                    <span class="badge bg-primary">POST /batch</span>
                  </div>
                  <p class="text-muted small mb-3">
                    Serão criados {{ formStep2.get('totalInstallments')?.value }} títulos com o mesmo documento base,
                    vencendo a cada {{ resolvedBillingIntervalDays }} dia(s) a partir da data inicial.
                  </p>
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label for="billingIntervalPreset" class="form-label">Intervalo entre vencimentos</label>
                      <select
                        id="billingIntervalPreset"
                        class="form-select"
                        formControlName="billingIntervalPreset">
                        <option *ngFor="let opt of billingIntervalPresets" [value]="opt.value">
                          {{ opt.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6" *ngIf="isBillingIntervalCustom()">
                      <label for="billingIntervalCustomDays" class="form-label">Dias personalizados</label>
                      <div class="input-group">
                        <input
                          type="number"
                          id="billingIntervalCustomDays"
                          class="form-control"
                          formControlName="billingIntervalCustomDays"
                          min="1"
                          max="365"
                          placeholder="Ex: 10" />
                        <span class="input-group-text">dias</span>
                      </div>
                    </div>
                  </div>

                  <div class="installment-preview mt-3" *ngIf="installmentPreview.length > 0">
                    <label class="form-label text-muted mb-2">Prévia dos títulos</label>
                    <div class="table-responsive preview-table-wrap">
                      <table class="table table-sm table-striped mb-0">
                        <thead>
                          <tr>
                            <th>Parcela</th>
                            <th>Vencimento</th>
                            <th class="text-end">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of installmentPreview">
                            <td>{{ row.installmentNumber }}/{{ formStep2.get('totalInstallments')?.value }}</td>
                            <td>{{ row.dueDate | date:'dd/MM/yyyy' }}</td>
                            <td class="text-end">{{ row.amount | currency:'BRL' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12">
                <div class="total-preview">
                  <h5>
                    {{ isBatchMode ? 'Total do lote' : 'Valor Total a Receber' }}:
                    <span class="text-success">{{ calculateTotalAmount() | currency:'BRL':'symbol':'1.2-2' }}</span>
                  </h5>
                  <small class="text-muted" *ngIf="isBatchMode">
                    {{ formStep2.get('totalInstallments')?.value }} parcelas de
                    {{ getInstallmentAmount() | currency:'BRL' }} (média; ver prévia)
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Cliente e Classificação -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-user me-2"></i>
              Cliente e Classificação
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-6">
                <label for="customerId" class="form-label">Cliente</label>
                <select 
                  id="customerId"
                  class="form-select"
                  formControlName="customerId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let customer of customers" [value]="customer.id">
                    {{ customer.name }}
                  </option>
                </select>
              </div>
              
              <div class="col-md-6">
                <label for="category" class="form-label">Categoria *</label>
                <select 
                  id="category"
                  class="form-select"
                  formControlName="category"
                  [class.is-invalid]="isFieldInvalid('category', 3)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let category of categoryOptions" [value]="category">
                    {{ category }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('category', 3)">
                  {{ getFieldError('category', 3) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="costCenterId" class="form-label">Centro de Custo</label>
                <select 
                  id="costCenterId"
                  class="form-select"
                  formControlName="costCenterId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let costCenter of costCenters" [value]="costCenter.id">
                    {{ costCenter.name }}
                  </option>
                </select>
              </div>
              
              <div class="col-md-6">
                <label for="subcategory" class="form-label">Subcategoria (Receita)</label>
                <input
                  type="text"
                  id="subcategory"
                  class="form-control"
                  formControlName="subcategory"
                  placeholder="Ex: Serviços de Oficina, Multas, Caução">
                <p class="form-text text-muted small mb-0 mt-1">
                  Usado para detalhar o plano de contas conforme CAD15.
                </p>
              </div>

              <div class="col-md-6">
                <label for="bankName" class="form-label">Banco</label>
                <input
                  type="text"
                  id="bankName"
                  class="form-control"
                  formControlName="bankName"
                  placeholder="Banco de recebimento (ex: Banco do Brasil, Itaú)">
              </div>

              <div class="col-md-6">
                <label for="receiptType" class="form-label">Tipo de Recebimento</label>
                <select
                  id="receiptType"
                  class="form-select"
                  formControlName="receiptType">
                  <option value="">Selecione...</option>
                  <option value="InfracaoTransito">Infração de Trânsito</option>
                  <option value="Avaria">Avaria</option>
                  <option value="LocacaoVeiculos">Locação de Veículos</option>
                  <option value="Caucao">Caução</option>
                  <option value="RescisaoContrato">Rescisão de Contrato</option>
                  <option value="TaxaServicoSuporte">Taxa de Serviço de Suporte</option>
                  <option value="Outros">Outros</option>
                </select>
                <p class="form-text text-muted small mb-0 mt-1">
                  Classifica o tipo de recebimento conforme CAD15.
                </p>
              </div>

              <div class="col-md-6">
                <label for="status" class="form-label">Status</label>
                <input type="hidden" formControlName="status">
                <input 
                  type="text" 
                  id="status"
                  class="form-control bg-light"
                  [value]="getStatusDisplayValue()"
                  readonly>
                <p class="form-text text-muted small mb-0 mt-1">
                  <i class="fas fa-lock me-1"></i> Automatizado: nasce como Pendente e só muda para Recebido quando o pagamento for confirmado (Asaas/BB).
                </p>
              </div>
            </div>
          </div>

          <!-- Navegação dos Steps -->
          <div class="step-navigation">
            <button 
              type="button" 
              class="btn btn-outline-secondary"
              (click)="previousStep()"
              [disabled]="currentStep === 1">
              <i class="fas fa-arrow-left me-2"></i>
              Anterior
            </button>
            
            <div class="step-info">
              Passo {{ currentStep }} de {{ totalSteps }}
            </div>
            
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="nextStep()"
              [disabled]="!canProceedToNextStep()"
              *ngIf="currentStep < totalSteps">
              Próximo
              <i class="fas fa-arrow-right ms-2"></i>
            </button>
            
            <button 
              type="button" 
              class="btn btn-primary"
              (click)="submitForm()"
              [disabled]="!isFormValid() || isSubmitting"
              *ngIf="currentStep === totalSteps">
              <i class="fas fa-save me-2"></i>
              {{ isEditMode ? 'Atualizar' : 'Salvar' }}
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm ms-2" role="status"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
